import { createContext, useReducer } from 'react';
import currentStepReducer, {
  CurrentStepReducerAction,
  currentStepReducerInitialState,
  CurrentStepReducerState,
} from '../../../redusers/current-step-reducer';
import paymentReducer, {
  PaymentReducerAction,
  paymentReducerinitialState,
  PaymentReducerState,
} from '../../../redusers/payment-reducer';
import vouchersReducer, {
  VouchersReducerAction,
  vouchersReducerInitialState,
  VouchersReducerState,
} from '../../../redusers/vouchers-reducer';
import customerReducer, {
  CustomerReducerAction,
  customerReducerInitialState,
  CustomerReducerState,
} from '../../../redusers/customer-reducer';
import termsReducer, {
  TermsReducerAction,
  termsReducerInitialState,
  TermsReducerState,
} from '../../../redusers/terms-reducer';
import errorReducer, {
  ErrorReducerAction,
  errorReducerinitialState,
  ErrorReducerState,
} from '../../../redusers/error-reducer';
import voucherReducer, {
  VoucherReducerAction,
  voucherReducerInitialState,
  VoucherReducerState,
} from '../../../redusers/voucher-reducer';
import isSummaryOpenReducer, {
  IsSummaryOpenAction,
  isSummaryOpenReducerInitialState,
  IsSummaryOpenState,
} from '../../../redusers/is-summary-open-reducer';
import loadingReducer, {
  LoadingReducerAction,
  loadingReducerInitialState,
  LoadingReducerState,
} from '../../../redusers/loading-reducer';
import createCombinedStateReducer from '../../../Utils/create-combined-state-reducer';

export type MembershipStateAction =
  | CurrentStepReducerAction
  | CustomerReducerAction
  | PaymentReducerAction
  | VoucherReducerAction
  | VouchersReducerAction
  | TermsReducerAction
  | IsSummaryOpenAction
  | LoadingReducerAction
  | ErrorReducerAction;

export interface MembershipStateCombinedState {
  state: {
    currentStep: CurrentStepReducerState;
    customer: CustomerReducerState;
    payment: PaymentReducerState;
    voucher: VoucherReducerState;
    vouchers: VouchersReducerState;
    terms: TermsReducerState;
    isSummaryOpen: IsSummaryOpenState;
    loading: LoadingReducerState;
    errors: ErrorReducerState;
  };
  dispatch: React.Dispatch<MembershipStateAction>;
}

const membershipStateInitialState: MembershipStateCombinedState = {
  state: {
    currentStep: currentStepReducerInitialState,
    customer: customerReducerInitialState,
    payment: paymentReducerinitialState,
    voucher: voucherReducerInitialState,
    vouchers: vouchersReducerInitialState,
    terms: termsReducerInitialState,
    isSummaryOpen: isSummaryOpenReducerInitialState,
    loading: loadingReducerInitialState,
    errors: errorReducerinitialState,
  },
  dispatch: () => {},
};

export const membershipState = createContext(membershipStateInitialState);

const membershipStateReducers = {
  currentStep: currentStepReducer,
  customer: customerReducer,
  payment: paymentReducer,
  voucher: voucherReducer,
  vouchers: vouchersReducer,
  terms: termsReducer,
  isSummaryOpen: isSummaryOpenReducer,
  loading: loadingReducer,
  errors: errorReducer,
};

interface MembershipStateProviderProps {
  children: React.ReactNode;
}

const MembershipStateProvider = (props: MembershipStateProviderProps) => {
  const membershipStateReducer = createCombinedStateReducer(membershipStateReducers);

  const [state, dispatch] = useReducer(
    membershipStateReducer,
    membershipStateInitialState.state
  );

  return (
    <membershipState.Provider value={{ state, dispatch }}>
      {props.children}
    </membershipState.Provider>
  );
};

export default MembershipStateProvider;
